import { createRoot } from "react-dom/client";
/*eslint-disable */
// Need to get the google api loaded
const script = document.createElement(`script`);
script.src = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
document.body.appendChild(script);

import React from "react";
import ReactDOM from "react-dom";
import polyFill from "./polyfills";

// Fire off the polyfill before the app starts up
polyFill();

//Find the root for React to render to
const interactiveMapApp = document.getElementById("interactiveMapApp");

//Add an event listener and render the App once the script has been added to the dom.
//Make the callback async so we can use the await keyword, when importing the App component
script.addEventListener(`load`, async () => {
  //We need to dynamically import the App component, after the google maps api has been loaded.
  //This prevents the error Uncaught ReferenceError: google is not defined.
  //Ie, in the maps.ts file, this error will occur if the api has not be instantiated
  //before the App component is rendered.

  //Dynamically import the App component
  const App = await import("./app");

  const root = createRoot(interactiveMapApp);
  root.render(<App.default />);
});
